<template>
    <div class="row">
        <div class="col-md-6">
            <div class="form-group mb-2">
                <small class="input-title">{{ data.package.type ? data.package.type : 'Tipo' }}</small>
                <label class="form-control form-control-sm text-muted bg-white">
                    <router-link :to="{ name: 'PackageDetail', params: { id: id }}" class="text-decoration-none">
                        {{`${data.package.type}${id}`}}
                        <i class="fa-solid fa-square-arrow-up-right"></i>
                    </router-link>
                </label>
            </div>
        </div>
        <div class="col-md-6">
            <small class="input-title">Peso</small>
            <label class="form-control form-control-sm text-muted bg-white">
                {{ Number(String(data.package.weight)).toFixed(2) }}
            </label>
        </div>
        <div class="col-12"></div>
        <div class="col-md-6">
            <div class="form-group mb-2">
                <small class="input-title">Impuesto</small>
                <search-tax v-model="data.tax_id" :tax="data.tax"/>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group mb-2">
                <small class="input-title">Cliente</small>
                <search-user v-model="data.user" @set_value="e => data.user_id = e"/>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group mb-2">
                <small class="input-title">Valor</small>
                <div class="input-group input-group-sm mb-2">
                    <div class="input-group-prepend">
                        <span class="input-group-text"><i class="bi bi-currency-dollar"></i></span>
                    </div>
                    <input type="text" v-model="data.value" class="form-control form-control-sm" placeholder="0.00" @keypress="DOUBLE">
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="form-group mb-2">
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <button @click="CALCULATE()"
                            type="button" v-bind="attrs" v-on="on"
                            class="btn btn-primary btn-h w-100" :disabled="!data.value || !data.tax_id">
                            <div class="spinner-border spinner-border-sm" role="status" v-if="calculate == 1">
                                <span class="sr-only">Loading...</span>
                            </div>
                            <span v-else><i class="bi bi-calculator"></i></span>
                        </button>
                    </template>
                    <small>Calcular</small>
                </v-tooltip>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group mb-3">
                <small class="input-title">Precio</small>
                <div class="input-group input-group-sm mb-2">
                    <div class="input-group-prepend">
                        <span class="input-group-text"><i class="bi bi-currency-dollar"></i></span>
                    </div>
                    <input type="text" v-model="data.subtotal" class="form-control form-control-sm" placeholder="0.00" @keypress="DOUBLE">
                    <div class="input-group-append">
                        <button type="button" class="btn btn-success btn-m" @click="ADD_LINE()">
                            <i class="bi bi-plus"></i>
                        </button>
                    </div>
                </div>
                <div class="row mb-2" v-for="(bill, i) in data.invoice_items" :key="i">
                    <div class="input-group input-group-sm col pl-0">
                        <div class="input-group-prepend">
                            <span class="input-group-text"><i class="bi bi-currency-dollar"></i></span>
                        </div>
                        <input type="text" v-model="bill.value" class="form-control form-control-sm" placeholder="0.00" @keypress="DOUBLE">
                    </div>
                    <div class="input-group input-group-sm col pr-0">
                        <input type="text" v-model="bill.description" class="form-control form-control-sm" placeholder="Descripción">
                        <div class="input-group-append">
                            <button type="button" class="btn btn-danger btn-m" @click="REMOVE_LINE(i)">
                                <i class="bi bi-x"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group mb-2">
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <button @click="CONFIRM()"
                            :disabled="!data.subtotal" type="button" v-bind="attrs" v-on="on"
                            class="btn btn-success btn-h w-100">
                            <div class="spinner-border spinner-border-sm" role="status" v-if="confirm == 1">
                                <span class="sr-only">Loading...</span>
                            </div>
                            <span v-else><i class="fa fa-save"></i>+ <i class="bi bi-check-lg"></i></span>
                        </button>
                    </template>
                    <small>Confirmar</small>
                </v-tooltip>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        prevent:{
            type: Boolean,
            default: false,
        }
    },
    data(){
        return{
            data: {
                package: {
                    type: '',
                    id: '',
                    weight: '',
                }
            },
            calculate: 0,
            confirm: 0,
            id: this.$route.params.id,
        }
    },
    created(){
        let vue = this
        vue.INIT()
    },
    methods: {
        INIT: function () {
            let vue = this
            axios({ url: '/packages/' + vue.id + '/invoice', method: 'GET' })
                .then((resp) => {
                    vue.data = resp.data
                })
                .catch((err) => {
                   let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                })
                .finally((resp) => {
                    vue.loading = false
                })
        },
        CALCULATE: function(){
            let vue = this
            vue.calculate++
            if(vue.calculate == 1){
                let data = {
                    package_id: vue.data.package_id,
                    tax_id: vue.data.tax_id,
                    value: Number(vue.data.value | 0),
                    weight: vue.data.weight,
                    user_id: vue.data.user_id,
                    weight_type: 1,
                }
                axios({url: '/calculate', method: 'POST', data: data })
                .then((resp) => {
                    var audio = new Audio(soundSuccess)
                    audio.play()
                    Object.entries(resp.data).forEach((element) => {
                        if(element[0] == 'invoice_items'){
                            if(typeof vue.data[element[0]] == 'undefined'){
                                vue.data[element[0]] = []
                            }
                            vue.data[element[0]] = element[1]
                        }else{
                            vue.data[element[0]] = element[1]
                        }
                    });
                })
                .catch((err) => {
                    var audio = new Audio(soundError)
                    audio.play()
                    if(err.response.status === 402 || err.response.status === 404){
                       let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    }else{
                        vue.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    }
                })
                .finally((resp)=>{
                    vue.calculate = 0
                })
            }
        },
        ADD_LINE: function(){
            let vue = this
            if(typeof vue.data.invoice_items == 'undefined'){
                vue.data.invoice_items = []
            }
            vue.data.invoice_items.push({ value: '', description: '', type: '' })
        },
        REMOVE_LINE: function(i){
            let vue = this
            if(typeof vue.data.invoice_items != 'undefined'){
                vue.data.invoice_items.splice(i, 1)
            }
        },
        CONFIRM: function () {
            let vue = this
            vue.confirm++
            if(vue.confirm == 1){
                let data = {
                    package_id: vue.id,
                    weight: vue.data.weight,
                    user_id: vue.data.user_id,
                    subtotal: vue.data.subtotal,
                    shipping: vue.data.shipping,
                    storage:vue.data.storage,
                    agency: vue.data.agency,
                    insurance: vue.data.insurance,
                    handling:vue.data.handling,
                    taxes: vue.data.taxes,
                    tax_id: vue.data.tax_id,
                    value: vue.data.value,
                    delivery: vue.data.delivery,
                    invoice_items: vue.data['invoice_items'],
                }
                axios({url: '/thinning/packages/save', method: 'POST', data: data })
                .then((resp) => {
                    var audio = new Audio(soundSuccess)
                    audio.play()
                    vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    if(!vue.prevent){
                        const routeData = vue.$router.resolve({name: 'PackageInvoice', params: { id: vue.id }})
                        window.open(routeData.href, '_blank')
                    }
                })
                .catch((err) => {
                    var audio = new Audio(soundError)
                    audio.play()
                    if(err.response.status === 422 || err.response.status === 402 || err.response.status === 404){
                       let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    }else{
                        vue.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    }
                })
                .finally((resp)=>{
                    vue.confirm = 0
                    if(vue.prevent){
                        vue.$emit('end')
                    }
                })
            }
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/packages/forms/invoice/Generate.vue